import React, { PureComponent } from 'react';
import {
    node,
    objectOf,
    oneOfType,
    string,
    number,
    bool,
    arrayOf,
} from 'prop-types';
import {
    FeatureFlags,
    processFeatureFlagsAndABTest,
    FEATURE_FLAGS,
} from 'utils';
import { withFeatureFlagsData } from 'connectors';
import { Provider } from './FeatureFlagsContext';

class FeatureFlagsProvider extends PureComponent {
    static propTypes = {
        children: node,
        flags: objectOf(oneOfType([string, number, bool, arrayOf(string)]))
            .isRequired,
    };

    static defaultProps = {
        children: null,
    };

    constructor(props) {
        super(props);

        const flags = processFeatureFlagsAndABTest({
            ...FEATURE_FLAGS,
            ...props.flags,
        });

        this.featureFlags = new FeatureFlags(flags);

        this.featureFlags.addAllListener(this.handleFeatureFlagChange);

        this.state = {
            featureFlags: this.featureFlags.flags,
        };
    }

    componentWillUnmount() {
        this.featureFlags.removeAllListener(this.handleFeatureFlagChange);
    }

    handleFeatureFlagChange = (flag, data) => {
        this.setState({
            featureFlags: {
                ...this.state.featureFlags,
                [flag]: data.value,
            },
        });
    };

    render() {
        const { children } = this.props;
        return (
            <Provider
                value={{
                    actions: {
                        getValue: this.featureFlags.getValue,
                        enableFlags: this.featureFlags.enableFlags,
                        enable: this.featureFlags.enable,
                        disable: this.featureFlags.disable,
                        isEnabled: this.featureFlags.isEnabled,
                        exists: flag => this.featureFlags.exists(flag),
                    },
                    state: {
                        featureFlags: this.state.featureFlags,
                    },
                }}
            >
                {children}
            </Provider>
        );
    }
}

export default withFeatureFlagsData(FeatureFlagsProvider);
